import type { ReactElement } from 'react';

const SKELETON_CARDS = 4;

/** 첫 로딩 자리표시 — 카드와 같은 정사각 회색 칸. 문구는 화면낭독기에만 읽힌다. */
export const QuoteDesignsSkeleton = (): ReactElement => (
  <div>
    <p role="status" className="sr-only">
      저장한 디자인을 불러오는 중입니다.
    </p>
    <div aria-hidden className="grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-6 lg:grid-cols-4">
      {Array.from({ length: SKELETON_CARDS }, (_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: 고정 개수의 장식 칸이다.
        <div key={index} className="flex flex-col gap-4">
          <div className="aspect-square w-full animate-pulse bg-muted/70" />
          <div className="h-4 w-2/3 animate-pulse bg-muted/70" />
        </div>
      ))}
    </div>
  </div>
);
